import React, { Component } from 'react';
import { LoginContext } from './LoginContext';

class FormTwo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPass: false,
    };
  }

  render(){
    let { logo, handleFieldChange, changeForm } = this.context;
    let { code } = this.context.formData;

    return (
      <div id = "wrapper">
        <div className="limiter">
          <div className="container-login100">
            <div className="wrap-login100 p-l-85 p-r-85 p-t-55 p-b-55">
              <form className="login100-form validate-form flex-sb flex-w" onSubmit={this.props.submit}>
                <span className="login100-form-title p-b-32"> <img height="100%" alt="DCNet_Logo" src={logo}></img> </span>
                <span className="txt1 p-b-11">Google Authenticator Code</span>
                <div className="wrap-input100 validate-input m-b-36">
                  <input autoFocus ref={this.context.codeRef} className="input100" type="text" name="code" value={code} onChange={handleFieldChange} autoComplete="off"></input>
                  <span className="focus-input100"></span>
                </div>
                <div className="flex-sb-m w-full p-b-48">
                </div>

                <div className="container-login100-form-btn">
                  <button type="submit" className="login100-form-btn" >
                    Done
                  </button>

                  <button id = "cancelLoginVerify" type="button" className="login100-form-btn" onClick={() => changeForm("one")}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div id="dropDownSelect1"></div>
      </div>
    );
  }
}

FormTwo.contextType = LoginContext;
export default FormTwo;


// WEBPACK FOOTER //
// ./src/Components/Login/FormTwo.js